import { Modal } from '@design-system/components/modal/modal';
import { ConfirmationCodeInput } from '@design-system/components/input/confirmationCodeInput';
import { useCodeVerificationModal } from './useCodeVerificationModal.hook';

type Props = {
  isOpen: boolean;
  email: string;
  onClose: () => void;
  onSuccessfulCodeVerification: (token: string) => Promise<unknown> | unknown;
};

export const CodeVerificationModal = ({
  isOpen,
  email,
  onClose,
  onSuccessfulCodeVerification,
}: Props) => {
  const { code, setCode, codeError, isSubmitting, verifyCode, onResend } =
    useCodeVerificationModal({ isOpen, email, onSuccessfulCodeVerification });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Enter verification code"
      centerContent
      modalClassName="w-full md:w-[600px]"
    >
      <div className="flex flex-col items-center gap-4 w-full">
        <p className="m-0 text-base text-black text-center">
          We&apos;ve sent a code to your email:
        </p>
        <p className="m-0 text-base text-black text-center font-bold">
          {email}
        </p>
        <ConfirmationCodeInput
          value={code}
          onChange={setCode}
          onComplete={verifyCode}
          error={codeError}
          disabled={isSubmitting}
        />
        <p className="m-0 text-sm text-[#9E9E9E] text-center">
          Please check your spam if you do not see it in your inbox.
        </p>
        <button
          type="button"
          onClick={onResend}
          className="border-0 bg-transparent p-0 cursor-pointer text-sm text-[#5F1ECC] hover:underline"
        >
          Didn&apos;t receive a code? Send again
        </button>
      </div>
    </Modal>
  );
};
